import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map,
} from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { normalizeAmount } from '../../utils/transformer.util';
import {
  Button,
  Select,
  Input,
  SelectScrollBar,

} from '../../components/base/index';
import IsiJadwalTable from './components/IsiJadwalTable.component';

const MySwal = withReactContent(Swal);

export default class TambahJadwalMatpel extends Component {
  constructor(props) {
    super(props);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._getParamOptions = this._getParamOptions.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._onDeleteList = this._onDeleteList.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._setForm = this._setForm.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this._getDayOptions = this._getDayOptions.bind(this);
    this._getClassesOptions = this._getClassesOptions.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getPrmMapelMasterOptions = this._getPrmMapelMasterOptions.bind(this);
    this._getPrmHourOptions = this._getPrmHourOptions.bind(this);
    this._getPrmTeacherOptions = this._getPrmTeacherOptions.bind(this);

    
    const { user, location } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;
    const { state = {} } = location;
    const { ttl_jp } = location.state;
    this.state = {
      form: {
        value: {
          levels_id,
          organizations_id,
          classrooms_id: '',
          units_id: school_unit.id,
          jadwal_matpel: [
            {
              mapel_div_id: '',
              teacher_id: '',
              hour_id: '',
            },
          ],
          rows: 
           Array.from({ length: ttl_jp }).map((_, i) => ({
            jp: i+1,
            hour: '',
            days: [
              {day_id: 2,
              kg:'',
              km:''
              },
              {day_id: 3,
              kg:'',
              km:''
              },
              {day_id: 4,
              kg:'',
              km:''
              },
              {day_id: 5,
              kg:'',
              km:''
              },
              {day_id: 6,
              kg:'',
              km:''
              },
              {day_id: 7,
              kg:'',
              km:''
              },
              {day_id: 1,
              kg:'',
              km:''
              },
            ],
      }))
          
        },
        error: {
          jadwal_matpel: '',
        },
      },
      param: {},
    };
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit } = user;
    if (type === 'classes' || type === 'classrooms') {
      filters.organizations_id = organizations_id;
      filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  componentDidMount() {
    const { location, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id, units_id, unit_code } = school_unit;
    const { state = {} } = location;
    const { filters, form } = this.state;
    const { isEdit = false, data } = location.state;
    const { id } = state.data || '';

    console.log(form.value)
    const paramTypes = ['classrooms', 'levels'];
    if (isEdit && data) {
      // this.setState({ id });
      this._setForm(data.units_id, data.periods_id, data.classrooms_id, data.semester_id);
    }

    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });
    this._getPrmHourOptions({ units_id: [school_unit.id]  });
    this._getPrmTeacherOptions({ units_id: [school_unit.id]  });

    this._getDayOptions();
    this._getClassesOptions({
      filters: { levels_id: [levels_id], units_id: [school_unit.id] },
    });
    this._getPeriodsOptions({ units_id: school_unit.id });

    // this._getPrmLevels({ filters: {units_id: [school_unit.id], organizations_id: organizations_id } });
  }


   async _getSemesterOptions(filters = {}) {
  const { getSemesterOptions } = this.props;

  const res = await getSemesterOptions(filters);

  const now = new Date();

  const currentSemester = res.find(item => {
    const startDate = new Date(item.start_date);
    const endDate = new Date(item.end_date);

    return now >= startDate && now <= endDate;
  });

  this.setState(prevState => ({
    ...prevState,

    param: {
      ...prevState.param,
      semesters: res,
    },

    form: {
      ...prevState.form,
      value: {
        ...prevState.form.value,
        semester_id: currentSemester
          ? currentSemester.value
          : "",
      },
    },
  }));
}
  


  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  async _getPeriodsOptions(filters = {}) {
  const { getPeriodsOptions } = this.props;
  const res = await getPeriodsOptions(filters);

  let currentPeriod = null;
  const date = new Date();

  res.forEach((data) => {
    const start_date = new Date(data.attributes.start_date);

    if (date > start_date) {
      currentPeriod = data.value;
    }
  });

  this.setState(prevState => ({
    ...prevState,
    form: {
      ...prevState.form,
      value: {
        ...prevState.form.value,
        periods_id: currentPeriod,
      },
    },
    param: {
      ...prevState.param,
      periods: res,
    },
  }), async () => {

    // Setelah periods_id sudah ketemu
    if (currentPeriod) {

      // Ambil semester berdasarkan periods_id
      await this._getSemesterOptions({
        periods_id: currentPeriod,
      });

      // Ambil mapel
      this._getPrmMapelMasterOptions({
        filters: {
          units_id: [this.props.user.school_unit.id],
          periods_id: currentPeriod,
        }
      });
    }
  });
}

  async _getPrmHourOptions(filters = {}) {
    const { getPrmHourOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id, units_id } = school_unit;
    const res = await getPrmHourOptions(filters);
    filters.units_id = units_id;
    // console.log(res)
    // console.log(res)
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        hour: res,
      },
    }));
  }
  
  async _getPrmTeacherOptions(filters = {}) {
    const { getPrmTeacherOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id, units_id } = school_unit;
    const res = await getPrmTeacherOptions(filters);
    filters.units_id = units_id;
    // console.log(res)
    // console.log(res)
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        teacher: res,
      },
    }));
  }

  async _getPrmMapelMasterOptions(filters = {}) {
    const { getPrmMapelMasterOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id, units_id } = school_unit;
    const res = await getPrmMapelMasterOptions(filters);
    filters.units_id = units_id;
    console.log(res)
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        subject: res,
      },
    }));
  }

  async _setForm(units_id, periods_id, classrooms_id, semester_id) {
    const { handleGetScheduleSubject, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;
    try {
      const payload = await handleGetScheduleSubject({ units_id, periods_id, classrooms_id, semester_id });
      // this._getPrmMapelMasterOptions({ filters: { classes_id: payload.classes_id } });

      this.setState({
        form: {
          value: {
            // id: payload.id,
            organizations_id: organizations_id,
            units_id: payload.units_id,
            classrooms_id: payload.classrooms_id,
            periods_id: payload.periods_id,
            semester_id: payload.semester_id,
            rows: map(payload.row, items => ({
              hour: items.hour,
              jp: items.jp,
              days: map(items.days, details => ({
                day_id: details.day_id,
                km: details.km,
                kg: details.kg,

              }))
            }))
            // jadwal_matpel: map(payload.jadwal_matpel, detail => ({
            //   mapel_div_id: detail.mapel_div_id,
            //   teacher_id: detail.teacher_id,
            //   hour_id: detail.hour_id,
            // })),
          },
          error: {
            jadwal_matpel: [],
          },
        },
      });
    } catch (err) {
      // err action
    }
  }

  async _getParamOptions(type, filters = {}) {
    const { getParamOptions, user } = this.props;
    const { organizations_id } = user;
    if (type === 'classrooms' || type === 'classrooms') {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptions(filters, type);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _getClassesOptions(filters = {}) {
    const { getClassesOptions, user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;
    filters.levels_id = levels_id;
    filters.units_id = school_unit.id;

    const res = await getClassesOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        classes: res,
      },
    }));
  }


  async _getDayOptions() {
    const { getDayOptions } = this.props;
    const res = await getDayOptions();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        day: res,
      },
    }));
  }

 

  async onSubmit() {
    const { history, handleSaveScheduleSubject } = this.props;
    const { form } = this.state;
    const { value } = form;
    const canSaveA = false;
    const dataForm = form.value;
    // if(dataForm.name && dataForm.publish_date && dataForm.tgl_selesai && dataForm.levels && dataForm.classrooms){
    //   canSaveA = true;
    // } else {
    //   canSaveA = false;
    // }
    // if (canSaveA == false){
    //   alert("Harap lengkapi data form. Bagian yang harus diisi ditandai dengan tanda bintang (*).");
    // } else {
    await handleSaveScheduleSubject(value);
    history.push('/dashboard/pengaturan/data-jadwal-matpel');
    // }
  }

  async onEdit() {
    const { history, handleEditScheduleSubject } = this.props;
    const { form } = this.state;
    const { value } = form;
    const res = await handleEditScheduleSubject(value);
    history.push('/dashboard/pengaturan/data-jadwal-matpel');
  }

  _onClickAdd(data) {
    const { form } = this.state;
    const { jadwal_matpel } = form.value;

    jadwal_matpel.push({
      Kelas: '',
      Matpel: '',
      // divisi: '',
      nominal: 0,
      // period:'',
    });

    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          jadwal_matpel,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const { jadwal_matpel } = prevState.form.value;
      const list = prevState.form.value.jadwal_matpel;

      list.splice(idx, 1);
      return {
        ...prevState,
        jadwal_matpel: list,
      };
    });
  }

  _onClickAddGroup() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/displiner/buat-group');
  }

  _onFormChange(event) {
    const {
      name, value, dataset, checked, type, files,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
      arrayDays = 0,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;
    const { filters, form } = this.state;
    this.setState((prevState) => {
      let newList = [];

      let newListError = [];
      let formattedValue = value;
      if (type === 'file') {
        formattedValue = files[0];
      }
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];

          // Pastikan objek pada arrayPosition sudah ada
      if (!newList[arrayPosition]) {
        newList[arrayPosition] = {};
      }
      console.log(arrayPosition, newList, newList[arrayPosition], newList[arrayPosition].days, arrayDays)

        // Tangani khusus untuk 'kg' dan 'km' agar tidak error
      if (name === 'kg' || name === 'km') {
        if (!newList[arrayPosition].days) {
          newList[arrayPosition].days = [];
        }
        if (!newList[arrayPosition].days[arrayDays]) {
          newList[arrayPosition].days[arrayDays] = {};
        }
        newList[arrayPosition].days[arrayDays][name] = formattedValue;
      } else {
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
      }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }

     
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      if (name === 'levels_id') {
        this._getClassesOptions({ filters: { levels_id: [value] } });
      }
      if (name === 'classrooms') {
        this._getStudentOptions({
          filters: { classrooms_id: value.map(item => item.value) },
        });
      }
      if (name === 'classes_id') {
        this._getParamOptionsAcademics('classrooms', {
          classes_id: value,
          organizations_id,
        });
        this._getPrmMapelMasterOptions({ filters: { classes_id: value,  period: form.value.periods_id } });
      }
    });
  }

  render() {
     const { location, user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { levels_id, units_id, unit_code } = school_unit;
    const { state = {} } = location;
    const { isEdit = false, data } = location.state;
    const { id } = state.data || '';
    const { form, param, filters } = this.state;
    const { value, error } = form;
    const { jadwal_matpel, rows } = form.value;
    const {
      handleGetKelas, handleDeleteKelas, coa, classrooms, days,
    } = this.props;
//  const rows = Array.from({ length: 9 });
  
//  console.log(rows)
    return (
      <div className="add-budget">
         <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
          <Select
            name="periods_id"
            label="Tahun Ajaran *"
            onChange={this._onFormChange}
            data={param.periods}
            placeholder="Pilihan"
            // disabled={true}
            value={form.value.periods_id}
            error={form.error.periods_id}
            isRequired
            disabled
          />
           <div className="manage-registration__custom-form-row-datadiri">
                <Select
                  name="semester_id"
                  label="Semester"
                  placeholder="Pilihan"
                  onChange={this._onFormChange}
                  data={param.semesters}
                  value={form.value.semester_id}
                  disabled={true}
                />
                </div>
              </div>
          <div className="absensi-rekap__custom-form-column__field">
            <Select
                  name="classrooms_id"
                  label="Kelas"
                  onChange={this._onFormChange}
                  placeholder="Pilih Kelas"
                  data={param.classrooms}
                  value={form.value.classrooms_id}
                  error={form.error.classrooms_id || ''}
                />
        </div>
         </div>
        <div className="nilai-kognitif__custom-form-row">
          <SelectScrollBar
          label="Kode Mata Pelajaran"
          options={param.subject}
           width={1000}
          height={150}
          fontSize={14}
            // disabled
          />
          <div className="data-pelanggaran__custom-form-row__field" />
           <SelectScrollBar
          label="Kode Guru"
          options={param.teacher}
           width={1000}
          height={150}
          fontSize={14}
            // disabled
          />
        </div>
        <br />

        <form onSubmit={this.onSubmit}>
          <table className="table" style={{width:'150%'}}>
                <thead>
                  <tr>
                    <th rowSpan={2}>JP</th>
                    <th rowSpan={2} style={{width:'10%'}} >Pukul</th>
                    <th colSpan={2}>Senin</th>
                    <th colSpan={2}>Selasa</th>
                    <th colSpan={2}>Rabu</th>
                    <th colSpan={2}>Kamis</th>
                    <th colSpan={2}>Jumat</th>
                    <th colSpan={2}>Sabtu</th>
                    <th colSpan={2}>Minggu</th>
                  </tr>
                  {/* {rows.map(list, idx) => {
                    list.days.map(data)
                  }} */}
                  <tr>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                    <th style={{width:'5%'}}>KM</th>
                    <th style={{width:'5%'}}>KG</th>
                
                  </tr>
                </thead>
                <tbody>
                 {rows.map((list, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td> <Input
                          type="text"
                          name="hour"
                          data-input-array
                          data-array-position={idx}
                          data-field-name="rows"
                          onChange={this._onFormChange}
                          value={list.hour}
                        /></td>
                        {list.days.map((data, idx2) => (
                          <>
                          <td> <Input
                              type="text"
                              name="km"
                              data-input-array
                              data-array-position={idx}
                              data-array-days={idx2}
                              data-field-name="rows"
                              onChange={this._onFormChange}
                              value={data.km}
                            />
                            </td>
                          <td> <Input
                            type="text"
                            name="kg"
                            data-input-array
                            data-array-position={idx}
                            data-array-days={idx2}
                            data-field-name="rows"
                            onChange={this._onFormChange}
                            value={data.kg}
                          /></td>
                          </>
                        )) }
                    
                  
                  </tr>
                ))}
                
                </tbody>
              </table>
          {/* <IsiJadwalTable
            list={jadwal_matpel}
            param={param}
            onAddList={this._onClickAdd}
            onFormChange={this._onFormChange}
            onDeleteList={this._onDeleteList}
          /> */}
        </form>
        <div className="manage-registration__footer">
          {id ? (
            <Button type="button" title="Update" onClick={this.onEdit} />
          ) : (
            <Button type="button" title="Simpan" onClick={this.onSubmit} />
          )}
        </div>
      </div>
    );
  }
}
TambahJadwalMatpel.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
TambahJadwalMatpel.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
